/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type ContactDealerProcurementCta_item = {|
  +serviceId: ?string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContactDealerProcurementCta_item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./assets/js/global/components/TradeProcurement/__generated__/ContactDealerProcurementCta_item.graphql.js